module.exports = __webpack_public_path__ + "static/battle_02-69587785488e073db0e0457dfd255a20.jpg";